module.exports = __webpack_public_path__ + "static/storm_giant_quintessent-5790743f278d14844fc2f63112514a8d.jpeg";